/**
 * Created with IntelliJ IDEA.
 * User: aprzybyszewski
 * Date: 07.06.13
 * Time: 16:43
 * To change this template use File | Settings | File Templates.
 */

import { AgeCheck } from "../constants/AgeCheck";
import { BasicConstants } from "../constants/BasicConstants";

export class IdentitiyManagementLicenseTableRegistrationVO {
    public gameTitle: string;
    public COMPANY_NAME: string = BasicConstants.COMPANY_NAME;
    public ageRating: AgeCheck;
    public license_cc_np: string;
    public gameRatingBoardConcessionDate: Date;
    public gameRatingBoardConcessionId: number;
    public productionDate: Date;

    public toString(): string {
        return "gameTitle: " + this.gameTitle +
            ", companyName: " + this.COMPANY_NAME +
            ", ageRating.name: " + this.ageRating.name +
            ", gameRatingBoardConcessionDate: " + this.gameRatingBoardConcessionDate +
            ", gameRatingBoardConcessionId: " + this.gameRatingBoardConcessionId +
            ", productionDate: " + this.productionDate;
    }
}
